/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getClientData} from '../redux/ClientCRUD'
import {useDispatch} from 'react-redux'
import * as client from '../redux/ClientRedux'
import ListClientData from './ListClientData'

const ListPage: FC = () => {
  const dispatch = useDispatch()

  const callClientData = async () => {
    try {
      let clientData = await getClientData(0, 10)
      if (clientData.data) {
        await dispatch(client.actions.setClientLoading(true))
        // once client data set then loading will automatically off using saga middleware
        await dispatch(client.actions.setClientData(clientData.data.docs))
        await dispatch(client.actions.setClientDataTotal(clientData.data.totalDocs))
      }
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  useEffect(() => {
    callClientData()
  }, [])

  return (
    <div>
      <ListClientData />
    </div>
  )
}

const ListWraaper: FC = () => {
  const intl = useIntl()

  return (
    <div>
      <PageTitle
        breadcrumbs={[
          {
            title: 'list',
            path: '/client/list',
            isActive: true,
            isSeparator: false,
          },
          {
            title: 'list',
            path: '/client/list',
            isActive: true,
            isSeparator: true,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.CLIENT'})}
      </PageTitle>
      <ListPage />
    </div>
  )
}

export {ListWraaper}
